export function updateCSRFToken(xhr) {
  const headerToken = xhr.getResponseHeader("X-CSRF-Token")
  if (headerToken) {
    document
      .querySelector("meta[name=csrf-token]")
      .setAttribute("content", headerToken)
  }
}
